import type { LegDTO } from '@/types/dto/agent';
import { replaceCarrier } from '@/utils/carriers';
import type { FC } from 'react';

interface CarrierLogoProps {
  carrier: LegDTO['carrier'];
}

const CarrierLogoImage: FC<CarrierLogoProps> = ({ carrier }) => {
  const displayCarrier = replaceCarrier(carrier);

  if (!displayCarrier?.name && !displayCarrier?.logoUrl) {
    return null;
  }

  return (
    <img
      src={displayCarrier.logoUrl}
      alt={displayCarrier.name || 'Carrier logo'}
      className="max-w-[50%]"
      data-testid="ws-carrier-logo-image"
    />
  );
};

export default CarrierLogoImage;
